<template>
  <div>
    <div style="height: 50px;margin-right: 10%;margin-top: 20px">
      <el-button style="float: right" type="primary" icon="el-icon-plus" @click="addUser()" >添加</el-button>
      <el-dialog title="添加角色" @close="closes" :visible.sync="dialogTableVisible" :append-to-body='true' :lock-scroll="false" >
        <AddAdmin></AddAdmin>
      </el-dialog>
    </div>
    <el-table :data="admin" class="tb-edit" style="width: 80%;margin: 20px auto;">
      <el-table-column type="select" min-width="10%"></el-table-column>
      <el-table-column prop="tu_id" label="角色ID" min-width="18%">
      </el-table-column>
      <el-table-column prop="tu_username" label="角色名称" min-width="18%">
      </el-table-column>
      <el-table-column label="创建时间" min-width="18%">
        <template slot-scope="scope">
          <p v-if="scope.row.tu_date == null"></p>
          <p v-else>{{scope.row.tu_date | moment}}</p>
        </template>
      </el-table-column>
      <el-table-column label="角色状态" min-width="15%">
        <template slot-scope="scope">
          <p v-if="scope.row.tu_valid == 0">禁用</p>
          <p v-else>启用</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="21%">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" size="small" type="primary" @click="updateUser(scope.row.tu_id,scope.row.tu_username,scope.row.tu_phone,scope.row.tu_valid)">编辑</el-button>
          <el-button icon="el-icon-delete" size="small" type="primary" @click="delUser(scope.row.tu_id,scope.row.tu_username)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="编辑角色" @close="closes" :visible.sync="dialogTableVisibles" :append-to-body='true' :lock-scroll="false" >
      <UpdateAdmin></UpdateAdmin>
    </el-dialog>

  </div>
</template>

<script>
  import AddAdmin from "./AddAdmin";
  import UpdateAdmin from "./UpdateAdmin";
    export default {
      inject:['reload'],
      components: {
        AddAdmin,
        UpdateAdmin
      },
      data (){
        return {
          admin:[],
          dialogTableVisible: false,
          dialogTableVisibles:false
        }
      },
      mounted() {
        this.getAdmin()
      },

      methods: {
        closes(){
          this.reload()
        },
        getAdmin(){
          this.$inbound.post({
            interfaceId: 'user/selectRowUser',
          }).then(response => {
            this.admin = response
          }).catch(error => {
            console.log(error)
          })

        },
        addUser(){
          this.dialogTableVisible = true;//默认页面不显示为false,点击按钮将这个属性变成true
        },
        updateUser(id,username,phone,valid){
          this.dialogTableVisibles = true;
          this.$router.push({
            query:{
              tu_id:id,
              tu_username:username,
              tu_phone:phone,
              tu_valid:valid
            }
          })
        },
        delUser(id,name) {
          this.$confirm('你确定要删除'+name+'吗？').then(_ => {
            this.$inbound.post({
              interfaceId: 'user/deleteUser',
              data: {
                tu_id: id
              }
            }).then(response => {
              window.location.reload()
            }).catch(error => {
              console.log(error)
            })
          }).catch(e => e);

        }
      }
    }
</script>

<style scoped>

</style>
